module.exports = __webpack_public_path__ + "img/A58A0129.d2625382.jpg";